/* eslint-disable prettier/prettier */

import { useCallback, useState } from 'react';
import { FiPlus } from 'react-icons/fi';
import { Link } from 'react-router-dom';

import { PINTO_BOOK_BASE_URL } from '../../app/ebooks/presenters/AboutDetailPresenter';
import KOLsTablePresenter from '../../app/kols/presenters/KOLsTablePresenter';
import useQueryPintoEbookCollections from '../../hooks/useQueryPintoEbookCollections';

const KOLsPage = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const pageLimit = 10;

  const { pintoEbookCollections, isLoadingPintoEbookCollections } = useQueryPintoEbookCollections({
    offset: (currentPage - 1) * pageLimit,
    limit: pageLimit
  });

  const handleChangePage = useCallback(
    (page: number) => {
      setCurrentPage(page);
    },
    [],
  );

  return (
    <div className="mx-auto space-y-24">
      <div className="space-y-24 divider-y">
        <div className="flex justify-between py-5">
          <h1 className="font-dbh text-[28px]">KOLs</h1>

          <div className="space-x-16 flex">
            <a target="_blank" className="block" href={`${PINTO_BOOK_BASE_URL}/explore-ebook-collections`} rel="noreferrer">
              <button className="space-x-8 btn btn-ghost">
                <span>หน้ารวมลิสต์ KOLs</span>
              </button>
            </a>
            <Link to="/kols/edit">
              <button className="space-x-8 btn btn-error">
                <FiPlus className="font-bold text-24" />
                <span>Create New KOL</span>
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div>
        {isLoadingPintoEbookCollections && <div className="w-full btn btn-outline btn-disabled bg-systemGrays04LabelQuaternary border-none loading h-[100px]" />}
        {!isLoadingPintoEbookCollections && (pintoEbookCollections?.edges?.length || 0) === 0 && (
          <div className="flex items-center justify-center w-full h-[60vh] text-colorsBrandWarmBlack02LabelSecondary">No kols data</div>
        )}
        {!isLoadingPintoEbookCollections && (pintoEbookCollections?.edges?.length || 0) > 0 && (
          <KOLsTablePresenter
            totalCount={pintoEbookCollections?.totalCount}
            pageLimit={pageLimit}
            currentPage={currentPage}
            onChangePage={handleChangePage}
            collectionItems={pintoEbookCollections?.edges.map((edge) => edge.node) || []}
          />
        )}
      </div>
    </div>
  );
};

export default KOLsPage;
